import { UiOption } from "@ui";

export const roleOptions: string[] = ['User', 'Admin', 'Super Admin'];
export const statusOptions: UiOption<string>[] = [
  { label: 'ใช้งาน', value: 'active' },
  { label: 'ไม่ใช้งาน', value: 'inactive' },
];
